export const isLoading = 'isLoading';
